/* Custom Hero — SlashBeauty slider */
(function () {
  class SlashHero extends HTMLElement {
    constructor() {
      super();
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      this.autoplayMs = parseInt(this.dataset.autoplayMs || '0', 10);
      this.timer = null;
    }

    connectedCallback() {
      this.initSound();
      if (this.slides.length <= 1) return;

      const next = this.querySelector('[data-next]');
      const prev = this.querySelector('[data-prev]');
      if (next) next.addEventListener('click', () => this.go(this.index + 1));
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));

      this.dots.forEach((dot) =>
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.dot, 10)))
      );

      // basic swipe
      let startX = 0;
      this.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
      this.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) this.go(this.index + (dx < 0 ? 1 : -1));
      }, { passive: true });

      if (this.autoplayMs > 0) this.startAutoplay();

      // pause autoplay when tab hidden
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stopAutoplay();
        else if (this.autoplayMs > 0) this.startAutoplay();
      });
    }

    initSound() {
      const btn = this.querySelector('[data-sound-toggle]');
      if (!btn) return;

      this.muted = true;
      btn.addEventListener('click', () => {
        this.muted = !this.muted;
        this.querySelectorAll('video').forEach((v) => { v.muted = this.muted; });
        btn.setAttribute('aria-pressed', String(!this.muted));
        btn.classList.toggle('is-muted', this.muted);
      });
    }

    go(i) {
      const len = this.slides.length;
      this.index = (i + len) % len;

      this.slides.forEach((s, n) => {
        const active = n === this.index;
s.classList.toggle('is-active', active);
        const vid = s.querySelector('video');
        if (vid) {
          if (active) { vid.play().catch(() => {}); }
          else { vid.pause(); }
        }
      });
      const track = this.querySelector('.slash-hero__slides');
      if (track) track.style.transform = 'translateX(-' + (this.index * 100) + '%)';
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === this.index));

      if (this.autoplayMs > 0) this.startAutoplay();
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setTimeout(() => this.go(this.index + 1), this.autoplayMs);
    }
    stopAutoplay() {
      if (this.timer) clearTimeout(this.timer);
    }
  }

  if (!customElements.get('slash-hero')) {
    customElements.define('slash-hero', SlashHero);
  }
})();